<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="OT">Contents</p>
<p class="CON3" id="toc1"><a href="#/Schroeder_Genesis_text_CC3#_idTOCAnchor-2">Editors’ Preface</a></p>
<p class="CON3" id="toc2"><a href="#/Schroeder_Genesis_text_CC4#_idTOCAnchor-3">Abbreviations</a></p>
<p class="CON3" id="toc3"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-14">Introduction</a></p>
<p class="CON4" id="toc4"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-13">Authors and Texts</a></p>
<p class="CON4" id="toc5"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-12">Drawing Upon the Fathers of the Church</a></p>
<p class="CON4" id="toc6"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-11">Remigius of Auxerre and Carolingian Biblical Interpretation</a></p>
<p class="CON4" id="toc7"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-10">Allegory in Twelfth-­Century Monastic Interpretation: <br/>Rupert of Deutz</a></p>
<p class="CON4" id="toc8"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-9">Hildegard of Bingen and the Interpretive Work of Medieval Women</a></p>
<p class="CON4" id="toc9"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-8">The School of Saint Victor: <br/>Andrew of Saint Victor’s <span class="h1emphasis">Exposition on Genesis</span></a></p>
<p class="CON4" id="toc10"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-7">Creating Resources for Medieval Students: <br/>Peter Comestor and the <span class="h1emphasis">Scholastic History</span></a></p>
<p class="CON4" id="toc11"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-6">Nicholas of Lyra: A Fourteenth-­Century Exegete</a></p>
<p class="CON4" id="toc12"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-5">Literal and Mystical Exegesis in the Fifteenth Century: <br/>Denis the Carthusian</a></p>
<p class="CON4" id="toc13"><a href="#/Schroeder_Genesis_text_CC5#_idTOCAnchor-4">About This Translation</a></p>
<p class="CON1">TRANSLATIONS</p>
<p class="CON2" id="toc14"><a href="#/Schroeder_Genesis_text_CC6#_idTOCAnchor-15">Remigius of Auxerre</a></p>
<p class="CON2" id="toc15"><a href="#/Schroeder_Genesis_text_CC7#_idTOCAnchor-16">Rupert of Deutz</a></p>
<p class="CON2" id="toc16"><a href="#/Schroeder_Genesis_text_CC8#_idTOCAnchor-17">Hildegard of Bingen</a></p>
<p class="CON2" id="toc17"><a href="#/Schroeder_Genesis_text_CC9#_idTOCAnchor-18">Andrew of Saint Victor</a></p>
<p class="CON2" id="toc18"><a href="#/Schroeder_Genesis_text_CC10#_idTOCAnchor-19">Peter Comestor</a></p>
<p class="CON2" id="toc19"><a href="#/Schroeder_Genesis_text_CC11#_idTOCAnchor-20">Nicholas of Lyra</a></p>
<p class="CON2" id="toc20"><a href="#/Schroeder_Genesis_text_CC12#_idTOCAnchor-21">Denis the Carthusian</a></p>
<p class="CON3" id="toc21"><a href="#/Schroeder_Genesis_text_CC13#_idTOCAnchor-22">Bibliography</a></p>
<p class="CON3" id="toc22"><a href="#/Schroeder_Genesis_text_CC14#_idTOCAnchor-23">Index of Names</a></p>
<p class="CON3" id="toc23"><a href="#/Schroeder_Genesis_text_CC15#_idTOCAnchor-24">Index of Subjects</a></p>
<p class="CON3" id="toc24"><a href="#/Schroeder_Genesis_text_CC16#_idTOCAnchor-25">Index of Scripture References</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Schroeder_Genesis_text_CC-2.vue?2c0e411e